import { createContext, useContext, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { HomeContext } from './contexHome';

export const TanqueContextC = createContext({});

export const NTanqueProvider = () => {
  const { socket } = useContext(HomeContext);

  const [modalStatus, setModalStatus] = useState(false);
  const [tanquesList, setTanquesList] = useState(null);
  const [modalAlertas, setModalAlertas] = useState(false);
  const [alertaList, setAlertaList] = useState([]);
  const [modalConfimetionBomba, setModalConfimationBomba] = useState(false);
  const [idControlerBomba, setIdControlerBomba] = useState(null);
  const [modalVazao, setModalVazao] = useState(false);

  return (
    <TanqueContextC.Provider
      value={{
        socket,
        setModalAlertas,
        modalAlertas,
        alertaList,
        setAlertaList,
        modalStatus,
        setModalStatus,
        tanquesList,
        setTanquesList,
        modalConfimetionBomba,
        setModalConfimationBomba,
        idControlerBomba,
        setIdControlerBomba,
        modalVazao,
        setModalVazao,
      }}
    >
      <Outlet />
    </TanqueContextC.Provider>
  );
};
